export interface SessionCases<T> {
  signedIn: () => T
  signedOut: () => T
  unknown: () => T
}

export class SignedIn {
  readonly kind = `signed-in`

  present = <T>(cases: SessionCases<T>): T => cases.signedIn()
}

export class SignedOut {
  readonly kind = `signed-out`

  present = <T>(cases: SessionCases<T>): T => cases.signedOut()
}

export class UnknownSession {
  readonly kind = `unknown-session`

  present = <T>(cases: SessionCases<T>): T => cases.unknown()
}

export type Session = SignedIn | SignedOut | UnknownSession

export interface Sessions {
  current: () => Promise<Session>
}
